export const getAppType = async () => {
	if (typeof wrapee !== 'undefined') {
		const deviceInfoResponse = await wrapee.getMobileMetrics();
		return deviceInfoResponse.appType; // Zwraca 'BuyerApp', 'SellerApp' lub inną wartość
	}
	// Domyślne zachowanie, gdy 'wrapee' jest niezdefiniowane
	return 'default';
};

export const isBuyerApp = async () => {
	const appType = await getAppType();
	if (appType) {
		return appType === 'BuyerApp';
	}
	// Zwraca wartość przechowywaną lokalnie, jeśli 'wrapee' jest niezdefiniowane
	return localStorage.getItem('isBuyerApp') === 'true';
};

export const isSellerApp = async () => {
	const appType = await getAppType();
	if (appType) {
		return appType === 'SellerApp';
	}
	// Zwraca wartość przechowywaną lokalnie, jeśli 'wrapee' jest niezdefiniowane
	return window.localStorage['IsApp'] === 'yes' && await isBuyerApp() === false;
};